module.exports = __webpack_public_path__ + "img/logo.471f6c6c.svg";